import React from 'react';
import { useRouteParams } from '../../hooks/useRouteParams';
import { useAppSelector } from '../../redux/hooks';
import boxTemplates from '../../templates/box';
import { BoxRendererWrapper } from './BoxRenderer.styles';

interface BoxRendererProps {}

const BoxRenderer: React.FC<BoxRendererProps> = () => {
  const { type, template } = useRouteParams();
  const boxData = useAppSelector(({ schema }) => schema);
  const storeConfiguration = useAppSelector(
    ({ configuration }) => configuration
  );
  const { global: globalConfiguration, template: templateConfiguration } =
    storeConfiguration;

  const templatesArr = boxTemplates[type];
  const colorsArr = globalConfiguration.enableGlobalColors
    ? globalConfiguration.colors
    : templateConfiguration[type]?.[template]?.colors;

  const colorMap = colorsArr
    ? colorsArr.map(({ colorId, colorValue }) => [
        `--tk-${colorId}`,
        colorValue,
      ])
    : [];

  const cssVariables = Object.fromEntries(colorMap);

  const Component = templatesArr.find(
    ({ name }) => name === template
  )?.component;

  if (!Component || boxData.type === '@init') return null;

  return (
    <BoxRendererWrapper style={cssVariables}>
      <Component
        formData={boxData}
        config={globalConfiguration.config}
        isPreview
      />
    </BoxRendererWrapper>
  );
};

export default BoxRenderer;
